<template>
  <div class="step-page">
    <div v-if="content">
      <div class="step-block">
        <div class="title-container">
          <Logo class="item" />
          <h4 class="item title">
            {{ title }}
          </h4>
          <div class="item"></div>
        </div>
      </div>

      <ValidationObserver v-slot="{ handleSubmit }">
        <div class="step-content" style="background: transparent">
          <div class="inner-card" style="color: #fff">
            <div v-html="content"></div>
            <div class="check-wrap">
              <ValidationProvider
                :rules="{ required: { allowFalse: false } }"
                v-slot="{ errors }"
              >
                <label>
                  <input type="checkbox" v-model="check" />
                  {{ $t("BUTTON.RESUME_AGREE") }}
                </label>
                <p v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
            <div class="text-center">
              <button
                type="button"
                class="btn btn-primary mt-4"
                @click="handleSubmit(agree)"
              >
                {{ $t("BUTTON.RESUME_SAVE") }}
              </button>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/company/Logo.vue";

export default {
  name: "DataConsent",
  components: {
    Logo,
  },
  data() {
    return {
      // 同意書 標題
      title: null,
      // 同意書 內容
      content: null,
      // 是否勾選同意
      check: false,
      // 需求單單號
      manpowerDemandNo: null
    };
  },

  methods: {
    // 取得 同意書最新版本
    getLatestVersion() {
      this.$api.resume.getConsent().then((response) => {
        if (response.status === 200) {
          this.title = response.data.Title;
          this.content = response.data.Content;
          localStorage.setItem("VERSION", response.data.Version);
        }
      });
    },

    // 儲存 同意書(勾選我同意)
    agree() {
      this.$api.resume
        .agreeConsent({
          UserId: this.$cookies.get("candidateId"),
          Version: localStorage.getItem("VERSION"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$router.push({ path: "/candidate/jobopening" });
          }
        });
    },
  },

  created() {
    this.getLatestVersion();
  },
};
</script>

<style lang="scss" scoped>
.btn-submit:disabled {
  background-color: #a8a8a8;
  cursor: not-allowed;
}

input[type="type"]:disabled {
  background-color: #fff;
}

input[type="radio"]:disabled {
  cursor: default !important;
}

input[type="radio"]:disabled + span {
  cursor: default;
}

#registerModal {
  .modal-body {
    padding: 0;
    position: relative;

    .title {
      background-color: #383838;
    }
  }
}
</style>
